import RoundedButton from "src/components/RoundedButton";
import { ShareInstagramStoryDataType, useShareInstagramStory } from "src/components/ShareMenu";
import IconFullInstagram from "src/icons/IconFullInstagram";

const RecapAssetShareInstagram = ({ data }: { data: ShareInstagramStoryDataType }) => {
	const { handlePress, loading } = useShareInstagramStory();

	return (
		<RoundedButton
			colorVariant="Contrast"
			sizeVariant="Large"
			Icon={IconFullInstagram}
			onPress={() => handlePress(data)}
			loading={loading}
		>
			Share to Insta
		</RoundedButton>
	);
};
export default RecapAssetShareInstagram;
